import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useGiveawayTimer } from 'root/src/client/v2/giveaways/hooks/useGiveawayTimer';
import { memo, useEffect } from 'react';
import { TimeLeftCountdown } from 'root/src/client/web/giveaway/features/GiveawaySection/TimeLeftCountdown';
import { queryClient } from 'root/src/client/v2/common/clients/queryClient';
import { giveawaysQueryKeys } from 'root/src/shared/giveaways/giveaways.keys';
import { twMerge } from 'tailwind-merge';
export const GiveawayTimer = memo(({ giveaway }) => {
    const { timeLeft, timeLeftParts, isPickingWinner, isWaitingForParticipants, participantsNeeded, interval } = useGiveawayTimer(giveaway);
    useEffect(() => {
        return () => {
            interval.clear();
            void queryClient.invalidateQueries({
                queryKey: giveawaysQueryKeys.giveawaysQueryKeySelector(),
            });
            void queryClient.invalidateQueries({
                queryKey: giveawaysQueryKeys.giveawaysPagedQueryKeySelector(),
            });
        };
    }, []);
    if (isPickingWinner) {
        return (<div className="flex flex-col justify-center items-center gap-2">
				<h1 className="font-mono uppercase font-bold text-center">Picking winner</h1>
				<LoadingCircles width={60} height={60}/>
			</div>);
    }
    if (isWaitingForParticipants) {
        const isUrgent = timeLeft < (5 * 60 * 1000); // 5 minutes in milliseconds
        return (<div className="flex flex-col items-center gap-1">
				<span className="text-light-4 uppercase text-xs">Waiting for participants</span>
				<div className={twMerge('text-xl font-bold font-mono text-center', isUrgent ? 'text-pink animate-pulse' : 'text-teal')}>
					{participantsNeeded} more needed
				</div>
				<div className="flex items-center gap-1 text-light-4 text-sm">
					<span>within</span>
					<span className="font-mono font-bold text-white">
						<TimeLeftCountdown {...timeLeftParts}/>
					</span>
				</div>
			</div>);
    }
    return <TimeLeftCountdown {...timeLeftParts}/>;
});
